import { render, staticRenderFns } from "./edit-credit-transfer.vue?vue&type=template&id=58f23098&scoped=true&"
import script from "./edit-credit-transfer.vue?vue&type=script&lang=js&"
export * from "./edit-credit-transfer.vue?vue&type=script&lang=js&"
import style0 from "./edit-credit-transfer.vue?vue&type=style&index=0&id=58f23098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f23098",
  null
  
)

export default component.exports